import axios from "axios";
import React, { Fragment, useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../Table/Table";
import { Helmet } from "react-helmet";
import Dashboard from "../Admin/Dashboard/Dashboard";
import CurrentDate from "../Admin/CurrentDate";
import Header from "../Admin/Dashboard/Header";
import baseApi from "../api";
import moment from "moment/moment";
import { Link } from "react-router-dom";
import ConfirmModal from "../ConfirmModal/ConfirmModal";

const base_url = process.env.REACT_APP_BASE_URL;
const Events = () => {
  //   const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsloading] = useState(false);
  const [itemTODelete, setItemToDelete] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleEdit = (id) => {
    // dispatch(appActions.setActiveEditLocationId(id));
    // localStorage.setItem("activeEditLocationId", id);
    // dispatch(appActions.setActiveEditType("Company"));
    // localStorage.setItem("activeEditType", "Company");
    // navigate("/editLocation");
  };

  const handleDelete = (id) => {
    setIsloading(true);
    let reqObj = {
      method: "DELETE",
      url: `${baseApi}event-webinar/remove-event-webinar/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwtToken")}`
      }
    };

    axios(reqObj)
      .then((res) => {
        setIsloading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsloading(false);
      });
  };

  const columns = [
    {
      name: "Title",
      selector: (row) => `${row.title}`,
      sortable: true,
      width: "330px",
      wrap: true
    },
    {
      name: "Description",
      selector: (row) =>
        `${row.description
          .replace(/<[^>]+>/g, "")
          .replace("&nbsp;", " ")
          .substring(0, 80)}...`,
      sortable: true,
      width: "330px",
      wrap: true
    },
    {
      name: "Short Description",
      selector: (row) => `${row.short_description.substring(0, 80)}...`,
      sortable: true,
      width: "330px",
      wrap: true
    },
    // {
    //   name: "Body Text",
    //   selector: (row) => `${row.body_text.substring(0, 80)}...`,
    //   sortable: true,
    //   width: "330px",
    //   wrap: true
    // },
    // {
    //   name: "Webinar link",
    //   selector: (row) => `${row.url.substring(0, 50)}...`,
    //   sortable: true
    // },
    {
      name: "Image",
      selector: (row) => (
        <img style={{ width: "100px", height: "60px" }} src={row.url} />
      ),
      sortable: false,
      width: "120px"
    },
    {
      name: "Date",
      selector: (row) => moment(row.createdAt).format("DD MMM YYYY"),
      sortable: true,
      width: "120px"
    },
    {
      name: "Action",
      width: "120px",
      cell: (row) => (
        <Fragment>
          <div>
            <div>
              <a
                href="#0"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setItemToDelete(row._id);
                  openModal();
                }}
              >
                <i className="fa fa-trash" aria-hidden="true"></i>
              </a>
              &nbsp;&nbsp;&nbsp;
              <Link to={"/edit-event/" + row.slug}>
                <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
              </Link>
              &nbsp;&nbsp;&nbsp;
              {/* <Link to={"/blog/" + row.slug}>
                <i className="fa fa-eye" aria-hidden="true"></i>
              </Link> */}
            </div>
          </div>
        </Fragment>
      )
    }
  ];
  const options = {
    // title: activeCompany.name,
    title: "Events",
    type: "Event",
    columns: columns,
    apiUrl: `${baseApi}event-webinar/list-events`,
    showAddBtn: true,
    AddBtnUrl: "/add-event"
  };

  return (
    <Fragment>
      <Header title="Events">
        <Table options={options} isLoading={isLoading} />
        <ConfirmModal
          isOpen={modalOpen}
          onClose={closeModal}
          type={"Event"}
          content={"Are you sure you want to delete this event?"}
          handleDelete={handleDelete}
          id={itemTODelete}
        />
      </Header>
    </Fragment>
  );
};

export default Events;
